import { render } from "./LuxuryTravel04.vue?vue&type=template&id=6e2ea454&scoped=true"
import script from "./LuxuryTravel04.vue?vue&type=script&lang=js"
export * from "./LuxuryTravel04.vue?vue&type=script&lang=js"

import "./LuxuryTravel04.scss?vue&type=style&index=0&id=6e2ea454&lang=scss&scoped=true&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e2ea454"]])

export default __exports__